import { http } from './_http';
import { logWebHrError } from "@/core/logger/log-wrapper";

/**
 * @return {Promise<AxiosResponse<any>>}
 */
export default async function getDocumentTypes(tenantId) {
  try {
    const { data } = await http.get(
      `/tenants/${tenantId}/document-type-settings`
    );

    return data.data;
  } catch (e) {
    logWebHrError({
      message: 'Failed to get document types',
      source: 'document-types-get',
      metadata: {
        tenantId,
      },
      error: e,
    });
    throw e;
  }
}
